// Helper para abrir o widget de webchat da Libben (script carregado em public/index.html).
//
// O webchat.js é uma IIFE que injeta um botão flutuante (#lc-btn) e NÃO expõe
// nenhuma API pública de abertura. A forma suportada de abrir programaticamente
// é disparar um clique nesse botão. Como o script é carregado com `async`, o
// botão pode ainda não existir no primeiro clique do usuário — por isso tentamos
// algumas vezes com um pequeno intervalo.

const LC_BTN_ID = 'lc-btn';
const LC_BOX_ID = 'lc-box';

function isChatOpen() {
  const box = document.getElementById(LC_BOX_ID);
  return !!box && box.style.display !== 'none' && box.style.display !== '';
}

/**
 * Abre o widget de webchat. Retorna true se conseguiu acionar o botão.
 * Faz algumas tentativas caso o script async ainda não tenha montado o botão.
 */
export function openWebchat() {
  let attempts = 0;
  const maxAttempts = 20; // ~5s (20 x 250ms)

  const tryOpen = () => {
    const btn = document.getElementById(LC_BTN_ID);
    if (btn) {
      // Só clica se ainda estiver fechado — evita fechar um chat já aberto.
      if (!isChatOpen()) btn.click();
      return true;
    }
    attempts += 1;
    if (attempts < maxAttempts) {
      setTimeout(tryOpen, 250);
    }
    return false;
  };

  return tryOpen();
}

/**
 * Handler para usar em onClick de links/botões que antes iam para /register.
 * Previne a navegação e abre o chat.
 */
export function handleTalkToSpecialist(event) {
  if (event && typeof event.preventDefault === 'function') event.preventDefault();
  openWebchat();
}
